import { BugoData } from '@shared/api/bugo/bugo.interface';
import { CourtesyContent } from '@shared/api/courtesyAsset/courtesyAsset.interface';

//* 기간이 지난 부고: 고인명·상주명·관계(reverseType)를 일절 쓰지 않는다.
// 예문들이 '저희 故OOO님 장례에' / '우리 故OOO님 장례에' 형태라
// '가족 장례'로 치환하면 모든 예문이 자연스럽게 읽힌다.
const ANONYMOUS_DECEASED_TEXT = '가족 장례';
const ANONYMOUS_DECEASED_NAME = '고인';
const ANONYMOUS_MEMBER_NAME = '유가족';

//* CourtesyCotent를 해당 member의 정보에 맞게 string으로 변경
const getCourtesyStringFromContent = (
  courtesyContent: CourtesyContent,
  bugo: BugoData,
  useDeceasedName = false,
  anonymous = false,
) => {
  const deceasedName = anonymous
    ? ANONYMOUS_DECEASED_NAME
    : bugo?.fevent?.deceasedInfo?.name;
  const memberName = anonymous
    ? ANONYMOUS_MEMBER_NAME
    : bugo?.member?.fullName ?? 'OOO';
  //!reverseType (관계도 개인정보이므로 익명 모드에선 쓰지 않는다)
  const reverseType = anonymous ? undefined : bugo?.member?.reverseType;
  const now = new Date();
  const dateString =
    now.getFullYear() + '년 ' + (now.getMonth() + 1) + '월 ' + now.getDate() + '일';

  let deceasedText: string;
  if (anonymous) {
    deceasedText = ANONYMOUS_DECEASED_TEXT;
  } else if (reverseType) {
    deceasedText = useDeceasedName
      ? `${reverseType}상(故 ${deceasedName}님)`
      : `${reverseType}상`;
  } else {
    deceasedText = `故${deceasedName}님 장례`;
  }

  return courtesyContent.content
    .replace('故${deceasedName}님 장례', deceasedText)
    .replace('故 ${deceasedName}님 장례', deceasedText)
    .replace('${deceasedName}', deceasedName)
    .replace('${memberName}', memberName)
    .replace('${dateString}', dateString);
};

export { getCourtesyStringFromContent };
